module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-wrap",
    class: {
      'component-padded': _vm.base.padded, 'active': _vm.active
    }
  }, [_c('div', {
    staticClass: "current-active"
  }), _vm._v(" "), _c('div', {
    staticClass: "component-body with-padding"
  }, [_c('div', {
    staticClass: "navigation"
  }, _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "nav-item"
    }, [_c('img', {
      staticClass: "nav-img",
      attrs: {
        "src": _vm.wximageurl + item.imgUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "nav-name"
    }, [_vm._v(_vm._s(item.content))])])
  }), 0)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fd4145d2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd4145d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/navigation.vue
// module id = 3001
// module chunks = 0